<template>
  <div id="choose">
    <div class="sectionIntro">
      <div class="sectionBack"></div>
      <div class="introContent">
        <div class="sectionVersion">
          <div class="versionGroup">
            <div class="version">
              <div class="imgContent">
                <img src="@/../static/image/content/indexVersion01.jpg" />
              </div>
              <div class="content">
                <h2 @click="getVersionPath(1)">
                  {{$t('avatamsaka.versions.version', {
                  'noticeType': $t(`avatamsaka.versions.type[0].text`)
                  })}}
                </h2>
                <p>{{$t('avatamsaka.choose.v1intro')}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="introCover">
        <img src="@/../static/image/content/chooseIntro.png" />
      </div>
    </div>

    <div class="sectionVersion">
      <div class="versionGroup">
        <div class="version">
          <div class="imgContent">
            <img src="@/../static/image/content/indexVersion02.jpg" />
          </div>
          <div class="content">
            <h2 @click="getVersionPath(2)">
              {{$t('avatamsaka.versions.version', {
              'noticeType': $t(`avatamsaka.versions.type[1].text`)
              })}}
            </h2>
            <p>{{$t('avatamsaka.choose.v2intro')}}</p>
          </div>
        </div>
        <div class="version">
          <div class="imgContent">
            <img src="@/../static/image/content/indexVersion03.jpg" />
          </div>
          <div class="content">
            <h2 @click="getVersionPath(3)">
              {{$t('avatamsaka.versions.version', {
              'noticeType': $t(`avatamsaka.versions.type[2].text`)
              })}}
            </h2>
            <p>{{$t('avatamsaka.choose.v3intro')}}</p>
          </div>
        </div>
      </div>
      <div class="versionGroup">
        <div class="version">
          <div class="imgContent">
            <img src="@/../static/image/content/indexVersion04.jpg" />
          </div>
          <div class="content">
            <h2 @click="getVersionPath(4)">
              {{$t('avatamsaka.versions.version', {
              'noticeType': $t(`avatamsaka.versions.type[3].text`)
              })}}
            </h2>
            <p>{{$t('avatamsaka.choose.v4intro')}}</p>
          </div>
        </div>
        <div class="version">
          <div class="imgContent">
            <img src="@/../static/image/content/indexVersion05.jpg" />
          </div>
          <div class="content">
            <h2 @click="getVersionPath(5)">
              {{$t('avatamsaka.versions.version', {
              'noticeType': $t(`avatamsaka.versions.type[4].text`)
              })}}
            </h2>
            <p>{{$t('avatamsaka.choose.v5intro')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'choose',
  data() {
    return {};
  },
  methods: {
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#choose {
  .sectionIntro {
    display: flex;
    padding-bottom: 50px;
    position: relative;

    .sectionBack {
      margin-bottom: 40px;
      width: 100%;
      height: 60%;
      background: #d9e2c4;
      position: absolute;
    }

    .sectionBack::after {
      border-top: 20vh solid #d9e2c4;
      border-right: 50vw solid transparent;
      border-left: 50vw solid transparent;
      content: "";
      top: 100%;
      left: 0;
      position: absolute;
    }

    .introCover {
      position: sticky;
      flex: 1.4;
      padding: 0px;
      margin: 0px;
      img {
        max-width: 500px;
        width: 100%;
        float: right;
      }
    }
    .introContent {
      p {
        padding: 20px;
        padding-left: 0px;
      }
      position: sticky;
      flex: 2;
      margin: 0px;
      padding: 0px;
      text-align: left;
      align-self: center;
      .sectionVersion {
        .versionGroup {
          height: 100%;
          min-height: 200px;
          width: 100%;
          margin: 0px;
          padding: 0px;
          display: grid;
          width: 100%;
          .version {
            background: transparent;
            margin: 30px;
            margin-top: 0px;
            padding: 20px;
            height: auto;
            overflow: visible;
            position: relative;

            .content {
              padding: 0px;
              width: calc(100% - 250px);
              overflow: visible;
              float: right;
              h2 {
                padding-bottom: 0px;
                font-weight: bold;
                margin-bottom: 0.5em;
                padding-top: 15px;
                line-height: 1.2em;
              }
              h2:hover {
                cursor: pointer;
              }
              p {
                margin: 0px;
                padding: 0px;
                position: relative;
                max-height: 12em;
                margin-right: -0.9em;
                padding-right: 0.9em;
                display: contents;
              }
            }
            .imgContent {
              padding-right: 0px;
              width: 220px;
              height: 344px;
              float: left;
              img {
                width: auto;
                height: calc(100% - 20px);
              }
            }
          }
        }
      }
    }
  }

  .sectionVersion {
    flex-direction: row;
    margin-top: 2em;

    .versionGroup {
      display: flex;

      .version {
        background: #d9e2c4;
        margin: 30px;
        padding: 20px;
        height: auto;
        flex: 1;
        position: relative;

        .content {
          width: calc(100% - 250px);
          text-align: left;
          padding: 15px;
          font-size: 1.1em;
          font-weight: 400;
          float: left;
          h2 {
            padding-bottom: 0.6em;
            font-weight: bold;
            margin-bottom: 0px;
          }
          h2:hover {
            cursor: pointer;
          }
          p {
            padding-top: 0px;
            margin-top: 0px;
          }
        }
        .imgContent {
          display: block;
          padding-right: 30px;
          width: 250px;
          img {
            width: 100%;
          }
          float: left;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    h2 {
      text-align: center;
    }

    button {
      display: block;
      margin: 20px auto;
    }

    .sectionIntro {
      .introCover {
        position: absolute;
        right: 0;
        padding: 0px;
        margin: 0px;
        img {
          max-width: 500px;
          width: 100%;
          float: right;
        }
      }
      .introContent {
        flex: 2;
        padding: 0px;
        z-index: 1;
        background: rgba(255, 255, 255, 0.55);
        margin: 20px;
        text-align: left;
        align-self: center;
        .sectionVersion {
          padding-top: 1em;
          .versionGroup {
            height: 100%;
            width: 100%;
            display: grid;
            width: 100%;
            .version {
              background: transparent;
              margin: 15px;
              margin-top: 0px;
              padding: 0px;
              height: auto;
              position: relative;

              .content {
                width: calc(100% - 128px);
                float: left;
                padding-left: 0.7em;
                line-height: 0px;
                h2 {
                  padding-bottom: 0px;
                  font-weight: bold;
                  padding-top: 0px;
                  font-size: 0.9em;
                  margin-bottom: 0px;
                  padding-left: 10px;
                  padding-right: 1em;
                  text-align: center;
                  padding-bottom: 1em;
                }
                h2:hover {
                  cursor: pointer;
                }
                p {
                  font-size: 0.8em;
                  margin: 0px;
                  padding-left: 15px;
                  overflow: hidden;
                  position: relative;
                  max-height: 12em;
                  text-align: left;
                  margin-right: 0px;
                  line-height: 1.4em;
                  display: block;
                  padding-right: 0.5em;
                }
                p:before {
                  content: "...";

                  position: absolute;
                  right: 0;
                  bottom: 0;
                }
              }
              .imgContent {
                padding-right: 0px;
                width: 128px;
                height: 200px;
                float: left;
                img {
                  width: auto;
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }

    .sectionVersion {
      margin-top: 0px;

      .versionGroup {
        height: 100%;
        width: 100%;

        display: grid;
        width: 100%;
        .version {
          background: #d9e2c4;
          margin: 30px;
          margin-top: 0px;
          padding: 20px;
          height: auto;
          position: relative;

          .content {
            width: calc(100% - 128px);
            overflow: hidden;
            float: left;
            padding-top: 0px;
            h2 {
              padding-bottom: 0px;
              font-weight: bold;
              font-size: 0.9em;
              margin-bottom: 0px;
              padding-bottom: 1em;
            }
            h2:hover {
              cursor: pointer;
            }
            p {
              font-size: 0.8em;
              margin: 0px;
              padding: 0px;

              overflow: hidden;
              position: relative;
              line-height: 1.2em;
              max-height: 12em;
              text-align: center;
              margin-right: -0.9em;
              padding-right: 0.9em;
            }
            p:before {
              content: "...";

              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
          .imgContent {
            padding-right: 0px;
            width: 128px;
            height: 200px;
            float: left;
            img {
              width: auto;
              height: 100%;
            }
          }
        }
      }

      :first-child {
        .version:first-child {
          margin-top: 30px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Choose.vue